const headerHeight =
    document.querySelector("header")?.getBoundingClientRect().height ?? 0;

/**
 * Smoothly scroll so the top of `target` sits just below the fixed header.
 *
 * @param {Element} target - The section to scroll into view.
 * @returns {void}
 */
function scrollBelowHeader(target) {
    const top =
        target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

    window.scrollTo({ top, behavior: "smooth" });
}

document.querySelector(".go-to-products")?.addEventListener("click", (e) => {
    /** @type {HTMLElement} */ (e.currentTarget).removeAttribute("href");

    const section = document.querySelector(".section-products");
    if (section) {
        scrollBelowHeader(section);
    }
});

document.querySelector(".go-to-footer")?.addEventListener("click", (e) => {
    /** @type {HTMLElement} */ (e.currentTarget).removeAttribute("href");

    const section = document.querySelector(".section-footer");
    if (section) {
        scrollBelowHeader(section);
    }
});

export {};
